import { createSelector } from 'reselect'

const getNextStepsSingleState = (state) => state.nextSteps.single

export const getNextStepsSingleDataState = createSelector([getNextStepsSingleState], (state) => state.data)
